import * as React from 'react';
import { useHistory } from 'react-router-dom';

import { QRCodeSVG } from 'qrcode.react';
import Modal from 'v2/components/Shared/Modal';

import mobileCreation from './mobile-creation.png';

type AppRedirectModalProps = {
  isOpen: boolean;
  setClose: () => void;
};

function AppRedirectModal({ isOpen, setClose }: AppRedirectModalProps) {
  const history = useHistory();
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 600;
  const APP_REDIRECT_URL = 'https://app.eduzz.com/?s=eyJzIjoiQmFua0FjY291bnQiLCJwIjp7ImNyZWF0ZUFjY291bnQiOnRydWV9fQ==';

  const handleGoToAddBankAccount = () => {
    history.push('/producer/profile/add-bank-account');
  };

  const handleRedirectToApp = () => {
    window.open(APP_REDIRECT_URL, '_blank');
    setClose();
  };

  return (
    <Modal
      open={isOpen}
      textTitle='Cadastrar nova conta bancária'
      textReturnButton='Cadastrar pelo site'
      textProceedButton='Cadastrar pelo App'
      setClose={setClose}
      handleProceedClick={handleRedirectToApp}
      handleReturnClick={handleGoToAddBankAccount}
    >
      <div className='flex max-md:flex-col'>
        <div>
          <p className='font-bold'>Chegou a hora de cadastrar sua conta bancária!</p>
          <p className='mt-2'>
            Facilitamos o caminho para você receber suas vendas.{' '}
            <b>Cadastre sua nova conta pelo App Eduzz e consiga aprovação de forma imediata.</b>
          </p>
          <p className='mt-2'>
            {!isMobile
              ? 'Abra sua câmera, escaneie o código ao lado e cadastre sua conta.'
              : 'Clique em "Cadastrar pelo App" e cadastre sua nova conta.'}
          </p>
          <p className='mt-2'>
            <a
              href='https://ajuda.eduzz.com/hc/pt-br/articles/4408955665051-Como-cadastrar-minha-conta-banc%C3%A1ria-no-App-Eduzz-'
              target='_blank'
              rel='noopener noreferrer'
            >
              Saiba mais.
            </a>
          </p>
        </div>
        <div className='flex items-center max-md:mt-10 max-md:justify-center md:ml-8 md:flex-col'>
          {!isMobile ? (
            <QRCodeSVG value={APP_REDIRECT_URL} />
          ) : (
            <img src={mobileCreation} alt='Criar conta bancária mobile' />
          )}
        </div>
      </div>
    </Modal>
  );
}

export { AppRedirectModal };
